import React, { useState } from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import fonts from "../../styles/fonts"
import colors from "../../styles/colors"
import DropdownArrow from "../../resources/img/ui/plp/dropdown.svg"
import { renderRichText } from "gatsby-source-contentful/rich-text"

const DescriptionContainer = styled.div`
  max-width: 1440px;
  margin: 78px auto 40px;
  padding: 0 16px;

  @media (min-width: ${breakpoints.md}) {
    padding: 0 32px;
    margin: 156px auto 80px;
  }

  @media (min-width: ${breakpoints.lg}) {
    padding: 0 45px;
  }

  @media (min-width: ${breakpoints.max}) {
    max-width: ${breakpoints.max};
  }
`

const Description = styled.div`
  border-top: 1px solid ${colors.trueBlack};
  border-bottom: 1px solid ${colors.trueBlack};
`

const DescriptionTitle = styled.div`
  padding: 24px 10px 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  h2 {
    ${fonts.selfModern};
    font-size: 20px;
    line-height: 1.5;
    color: ${colors.black};
  }

  @media (min-width: ${breakpoints.md}) {
    h2 {
      font-size: 24px;
    }
  }
`

const Arrow = styled.img`
  transform: ${(props) => (props.open ? "rotate(180deg)" : "rotate(0)")};
  transition: transform 0.2s ease;
`

const Drawer = styled.div`
  max-height: ${(props) => (props.visible ? "auto" : "0")};
  overflow: hidden;
`

const Content = styled.div`
  padding-bottom: 20px;
  ${fonts.helveticaNeueLight};
  font-size: 14px;
  line-height: 26px;
  color: ${colors.textGrey};
  letter-spacing: 0;

  h2 {
    ${fonts.helveticaNeueLight};
    font-size: 16px;
    margin-bottom: 4px;
    color: ${colors.textGrey};
    b {
      ${fonts.helveticaNeueCondensedBold};
    }
  }

  h3 {
    ${fonts.helveticaNeueLight};
    font-size: 14px;
    margin-bottom: 4px;
    color: ${colors.textGrey};
    b {
      ${fonts.helveticaNeueCondensedMedium};
    }
  }

  p {
    margin-bottom: 14px;
    a {
      color: ${colors.green};
    }
    b {
      ${fonts.helveticaNeueCondensedMedium};
    }

    &:last-of-type {
      margin-bottom: 0px;
    }
  }
`

const CollectionDescription = ({ title, description, materialColor }) => {
  const [open, setOpen] = useState(false)

  if (!title || !description) return null

  const options = {
    renderText: (text) =>
      text && typeof text !== "undefined"
        ? text.replace("[colour]", materialColor ? materialColor : "")
        : "",
  }

  return (
    <DescriptionContainer>
      <Description>
        <DescriptionTitle onClick={() => setOpen(!open)}>
          <h2>{title}</h2>
          <Arrow src={DropdownArrow} alt="arrow" open={open ? 1 : 0} />
        </DescriptionTitle>
        <Drawer visible={open ? 1 : 0}>
          <Content>{renderRichText(description, options)}</Content>
        </Drawer>
      </Description>
    </DescriptionContainer>
  )
}

export default CollectionDescription
